import {
    GET_MODULE_MASTER_LIST_SUCCESS,
    GET_MODULE_MASTER_LIST_FAILED,
    LOADING_MODULE_MASTER_LIST,
    NETWORK_ERROR_MODULE_MASTER_LIST
} from "../types/index";
import { adminServices } from "../../config/axios";

const adminGetModuleMaster =
    (userData, authTokenIs) => async (dispatch) => {
        dispatch({ type: LOADING_MODULE_MASTER_LIST });
        await adminServices
            .post("ModulemasterList", userData, { headers: { AuthToken: authTokenIs } })
            .then((res) => {
                switch (res.data.status) {
                    case "success":
                        dispatch({ type: GET_MODULE_MASTER_LIST_SUCCESS, payload: res.data });
                        break;
                    default:
                        dispatch({ type: GET_MODULE_MASTER_LIST_FAILED, payload: res.data });
                        break;
                }
            })
            .catch((err) => {
                dispatch({
                    type: NETWORK_ERROR_MODULE_MASTER_LIST,
                    payload: err
                });
            });
    };

export { adminGetModuleMaster };
